module.exports = __webpack_public_path__ + "static/img/弹窗-固废.e458c1d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/comp/弹窗-固废.png
// module id = danE
// module chunks = 3